import { isEqualUtil } from '../../lang'

/**
 * Checks whether the given arrays contains the same elements,
 * regardless of the order.
 * @param  {Array}  arr1
 * @param  {Array}  arr2
 * @returns {Boolean}
 */
export default function isEqualContentDeepArrayUtil (arr1, arr2) {
  if (arr1.length !== arr2.length) {
    return false
  }
  return arr1.every(elem => !!arr2.find(el => isEqualUtil(el, elem)))
}
